import { IconProps } from './interfaces';

export const IconAudioPlayButtonFilledShadow = ({ className, role }: IconProps) => (
    <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" className={className} role={role}>
        <filter filterUnits="objectBoundingBox" height="166.7%" id="a" width="166.7%" x="-33.3%" y="-22.9%">
            <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4.5" />
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.92 0 0 0 0.28 0" />
        </filter>

        <g transform="translate(9 4)">
            <circle id="b_2_" cx="24" cy="24" r="24" style={{ filter: 'url(#a)' }} />
            <circle id="b_1_" cx="24" cy="24" r="24" fill="currentColor" />
        </g>
        <path fill="#FFFFFF" d="M39.2,28l-9.7,6.5V21.5L39.2,28z" />
    </svg>
);
